<script setup>
import { ref } from 'vue';

const isHovered = ref(false);

const props = defineProps({
    title: String,
    subtitle: String,
    index: Number,
    image: {
        src: String,
        width: Number,
        height: Number,
        fit: String,
        position: String
    },
});

const handleMouseOn = () => {
    isHovered.value = true;
};

const handleMouseLeave = () => {
    isHovered.value = false;
};

const imageStyles = {
    display: 'block',
    objectPosition: props.image.position,
    objectFit: props.image.fit,
    width: "100%",
    height: "100%",
};

const imageHidden = {
    display: "none"
}
</script>

<template>
    <div 
        class="card"
        @pointerenter="handleMouseOn"
        @pointerleave="handleMouseLeave"
        :style="isHovered ? {color: 'white'} : {}"
    >
        <div class="image-wrapper">
            <img 
                class="image"
                :src="props.image.src" 
                :style="isHovered ? imageStyles : imageHidden"
            /> 
        </div>

        <div v-if="isHovered" class="gradient"/>

        <div class="text">
            <div class="card-head">
                <h3 class="title">
                    <i18n-t :keypath="props.title">
                        <template #brake>
                            <br/>
                        </template>
                    </i18n-t>
                </h3>
                <span class="index">{{ props.index }}</span>
            </div>

            <div class="card-body">
                <p class="subtitle">{{ $t(props.subtitle) }}</p>
            </div>
        </div>
    </div>
</template>

<style scoped>
.card {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    box-sizing: border-box;

    border: 2px solid #E5F2FF;
    background-color: rgba(125, 188, 255, 0.1);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center top;

    color: #373737;

    border-radius: 0;

    position: relative;
    overflow: hidden;
}

.text {
    position: absolute;
    padding: 20px;
    height: auto;
    width: auto;

    display: flex;
    justify-content: space-between;

    flex-direction: column;

    overflow: hidden;

    width: 100%;
    height: 100%;
}

.image {
    position: relative;
}

.gradient {
    background: linear-gradient(0deg, #000000FF 0%, #00000000 50%);
    height: 100%;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
}

.card-head {
    display: flex;
    justify-content: space-between;
    align-items: start;
}

.card-body {
    padding: 0;
    height: fit-content;
    flex: unset;
}

.title, .index, .subtitle {
    margin: 0;

    font-size: 20px;
}

.title, .index {
    font-weight: 600;
    text-transform: uppercase;
}

.subtitle {
    max-width: 337px;
}

@media screen and (max-width: 1280px) {
    .card {
        height: 230px;
        width: 350px;
    }
}
</style>